import Web3 from 'web3';

// Singleton promise ensures only one version of web3 provider:
const loadWeb3Once = new Promise((resolve, reject) => {

  // Wait for loading completion to avoid race
  // conditions with web3 injection timing:
  window.addEventListener('load', () => {

    var _web3 = window.web3;

    if (typeof _web3 === 'undefined') {
      return reject('No web3 instance injected.');
    }

    // Use Mist/MetaMask's provider.
    let provider = new Web3(_web3.currentProvider);
    resolve(provider);

  });
});

export const getWeb3 = () => {
  return loadWeb3Once;
};

export const getAccounts = () => {
  return new Promise((resolve, reject) => {
    getWeb3().then((web3) => {
      web3.eth.getAccounts((error, accounts) => {

        if (error) { return reject(error); }
        resolve(accounts);

      });
    }).catch(reject);
  });
};

export const getNetworkId = () => {
  return new Promise((resolve, reject) => {
    getWeb3().then(web3 => {
      web3.eth.net.getId().then(resolve);
    }).catch(reject);
  });
};

export const getBlockNumber = function() {
  return new Promise((resolve, reject) => {
    getWeb3().then((web3) => {
      web3.eth.getBlockNumber().then(resolve);
    }).catch(reject);
  });
}




// WEBPACK FOOTER //
// ./src/util/web3Helpers.js